import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import PreviewImage from '@plone/volto/components/theme/PreviewImage/PreviewImage';
import {
  Card,
  Grid,
  Label,
  Header,
} from 'semantic-ui-react';
import { formatDate, truncateText } from '../../../utils/blocks';

const EXCERPT_MAX_CHARS = 100;

interface NewsCardItem {
  '@id'?: string;
  title: string;
  description?: string;
  CreationDate: string;
  Subject?: string[];
  image_field?: string;
  [key: string]: unknown;
}

interface NewsCardTemplateProps {
  items: NewsCardItem[];
}

const NewsCardTemplate = ({ items }: NewsCardTemplateProps) => {
  return (
    <Grid stackable columns={3}>
      {items.map((item, index) => {
        const itemDate = formatDate(item.CreationDate);
        const itemHref = flattenToAppURL(item['@id'] || '');

        return (
          <Grid.Column key={`${item.title}-${index}`}>
            <div className="news-card-wrapper">
              <Card fluid raised>
                <div>
                  <PreviewImage
                    item={item}
                    image_field={item.image_field}
                    alt={item.title}
                    className="news-card-image"
                  />
                </div>
                <Card.Content>
                  {!!item.Subject?.length && (
                    <Label.Group size="mini">
                      {item.Subject.map((subject, idx) => (
                        <Label basic key={subject || idx}>
                          {subject}
                        </Label>
                      ))}
                    </Label.Group>
                  )}
                  <Header
                    as="h3"
                    size="medium"
                  >
                    {item.title}
                  </Header>
                  <Card.Meta>{itemDate}</Card.Meta>
                  <Card.Description>
                    {truncateText(
                      item.description,
                      EXCERPT_MAX_CHARS,
                    )}
                  </Card.Description>
                </Card.Content>
                <Card.Content extra>
                  <a href={itemHref}>
                    Read More →
                  </a>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
        );
      })}
    </Grid>
  );
};

export default NewsCardTemplate;